<template>
  <!-- 自己写 -->
  <div class="formBox">
    <div
      class="formRow"
      v-for="(item, index) in infoFieldsCopy"
      :key="'crmInfoFields' + index"
    >
      <label>{{ item.fieldName }}:</label>
      <!-- 多行文本框 -->
      <span v-if="item.fieldFormType === 'textarea'">
        <a-textarea
          v-model="infoModels[item.fieldCode]"
          disabled
          size="small"
        />
      </span>
      <!-- 选择器 -->
      <span v-else-if="item.fieldFormType === 'select'">
        <a-select
          :value="infoModels[item.fieldCode]?infoModels[item.fieldCode].toString():''"
          optionFilterProp="label"
          disabled
          size="small"
        >
          <a-select-option
            v-for="item in JSON.parse(item.options)"
            :value="item.value.toString()"
            :label="item.label"
            :key="item.value"
            >{{ item.label }}</a-select-option
          >
        </a-select>
      </span>
      <!-- 单选框 -->
      <span v-else-if="item.fieldFormType === 'radio'" style="white-space: initial">
        <a-radio-group :value="infoModels[item.fieldCode]" disabled>
          <a-radio
            :value="item.value.toString()"
            v-for="item in JSON.parse(item.options)"
            :key="item.value"
          >
            {{ item.label }}
          </a-radio>
        </a-radio-group>
      </span>
      <!-- 多选框 -->
      <span
        v-else-if="item.fieldFormType === 'checkbox'"
        style="white-space: initial"
      >
        <a-checkbox-group
          :value="infoModels[item.fieldCode]||[]"
          disabled
          size="small"
        >
          <a-row>
            <a-checkbox
              v-for="item in JSON.parse(item.options)"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-checkbox>
          </a-row>
        </a-checkbox-group>
      </span>
      <!-- 日期 -->
      <span v-else-if="item.fieldFormType === 'date'">
        <a-date-picker
            v-model="infoModels[item.fieldCode]"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            disabled
            size="small"
            :showTime="true"
            allowClear
            :locale="zh_CN"
        />
      </span>
      <!-- 时间选择框 -->
      <span v-else-if="item.fieldFormType === 'time'">
        <a-time-picker
            v-model="infoModels[item.fieldCode]"
            format="HH:mm:ss"
            disabled
            size="small"
            valueFormat="HH:mm:ss"
        />
      </span>
      <!-- 区域选择框 -->
      <span v-else-if="item.fieldFormType === 'region' || item.fieldFormType === 'cascade'" >
        <!-- <a-cascader
            disabled
            size="small"
            v-model="infoModels[item.fieldCode]"
            :field-names="{
                label: 'name',
                value: 'code',
                children: 'children',
            }"
        /> -->
        {{ infoModels[item.fieldCode] }}
      </span>
      <!-- 图片文件 -->
      <span v-else-if="item.fieldFormType === 'file'">
       <template v-for="item2 in arrM(infoModels[item.fieldCode])">
        <img
          v-if="item2"
            v-show="
                item2.split('.')[1] == 'jpg' ||
                item2.split('.')[1] == 'png' ||
                item2.split('.')[1] == 'gif'
            "
            class="uploadImg"
            :src="getFileAccessHttpUrl(item2,'',projectType)"
            alt=""
            v-viewer
        />
       </template>
      </span>
      <!-- 富文本 -->
      <span v-else-if="item.fieldFormType === 'richtext'">
        <div class="fwb" v-html="infoModels[item.fieldCode]"></div>
      </span>
      <!-- 输入框 -->
      <span
        v-else
      >
        <a-input :value="infoModels[item.fieldCode]" disabled size="small" />
      </span>
    </div>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { getFileAccessHttpUrl } from '@/utils/index';
export default {
  props: {
    infoFields: {
      type: Array,
      default: () => [],
    },
    infoModels: {
      type: Object,
      default: () => [],
    },
    projectType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      zh_CN,
      getFileAccessHttpUrl,
      infoFieldsCopy:'',
    };
  },
  methods: {
    // 字符串转数组-用于头像文件
    arrM(item){
      if(item) return item.split(',')
      else return ''
    }
  },
  mounted() {
    this.infoFieldsCopy = JSON.parse(JSON.stringify(this.infoFields))
  },
};
</script>

<style lang="less" scoped>
.formBox {
  :deep(.ant-checkbox-wrapper) {
    margin-left: 0 !important;
  }
  :deep(.ant-select),:deep(.ant-time-picker),:deep(.ant-calendar-picker){
    width: 100% !important;
  }
  :deep(.ant-select-disabled),:deep(.ant-input-disabled){
    color: rgba(0, 0, 0, 0.55);
  }
  img{
    height: 80px;
    margin-right: 10px;
  }
  .fwb{}
}
</style>

